import { lazy } from "react";
import { loadDynamic } from "./loadDynamic";

// Helper pour lazy + export nomme (retry dynamic-import via loadDynamic).
// React.lazy() attend ComponentType<any> dans sa contrainte (cf. LazyExoticComponent) ;
// ComponentType<unknown> echoue car les composants exportent leurs propres props
// (le type du module ne se restreint pas a ComponentType<unknown>).
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- requis par la signature de React.lazy
export function lazyNamed<T extends Record<string, React.ComponentType<any>>>(
  factory: () => Promise<T>,
  name: keyof T,
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- meme raison que la contrainte ci-dessus
  return lazy(() => loadDynamic(factory).then((m) => ({ default: m[name] as React.ComponentType<any> })));
}
